import { useContext } from "react";
import {
  ContextValues,
  CurrentUserContext,
} from "../context-api/current-user/context";

export const useCurrentUser = (): ContextValues => {
  return useContext(CurrentUserContext);
};
